export const teamWorkflow = {
  junior: {
    processes: [
      { name: 'Daily Standup', description: 'Report on both frontend and backend progress', time: '9:00 AM daily' },
      { name: 'Full-stack Code Review', description: 'Review changes across the entire stack', requirement: 'Minimum 2 approvals for full-stack PRs' },
      { name: 'Integration Testing', description: 'Test frontend-backend integration', coverage: 'End-to-end test coverage required' }
    ],
    responsibilities: [
      { area: 'Feature Development', tasks: ['Design API contracts', 'Implement backend logic', 'Build frontend UI', 'Integration testing'] },
      { area: 'Bug Resolution', tasks: ['Identify stack layer', 'Debug across frontend/backend', 'Fix root cause', 'Verify end-to-end'] },
      { area: 'Documentation', tasks: ['API documentation', 'Component documentation', 'Integration guides'] }
    ],
    ceremonies: [
      { name: 'Sprint Planning', frequency: 'Bi-weekly', duration: '2 hours', role: 'Plan full-stack features' },
      { name: 'Sprint Review', frequency: 'Bi-weekly', duration: '1 hour', role: 'Demo complete features' },
      { name: 'Technical Sync', frequency: 'Weekly', duration: '30 minutes', role: 'Discuss integration challenges' }
    ]
  },
  mid: {
    processes: [
      { name: 'Architecture Review', description: 'Review full-stack architecture decisions', frequency: 'Weekly' },
      { name: 'Performance Optimization', description: 'Optimize across frontend and backend', responsibility: 'End-to-end performance' },
      { name: 'Cross-team Coordination', description: 'Bridge frontend and backend teams', commitment: 'Facilitate communication' }
    ],
    responsibilities: [
      { area: 'System Design', tasks: ['Design scalable architectures', 'Plan database schemas', 'Design API contracts', 'Frontend architecture'] },
      { area: 'Team Leadership', tasks: ['Mentor junior developers', 'Lead technical discussions', 'Code review leadership'] },
      { area: 'Integration', tasks: ['Ensure smooth frontend-backend integration', 'Resolve integration issues', 'Optimize data flow'] }
    ],
    ceremonies: [
      { name: 'Architecture Review', frequency: 'Weekly', duration: '1 hour', role: 'Lead full-stack discussions' },
      { name: 'Performance Review', frequency: 'Monthly', duration: '2 hours', role: 'Analyze end-to-end performance' },
      { name: 'Cross-team Sync', frequency: 'Bi-weekly', duration: '1 hour', role: 'Coordinate between teams' }
    ]
  },
  senior: {
    processes: [
      { name: 'Strategic Planning', description: 'Define full-stack technology strategy', scope: 'Company-wide impact' },
      { name: 'Technical Leadership', description: 'Lead major architectural decisions', responsibility: 'End-to-end system ownership' },
      { name: 'Innovation Planning', description: 'Evaluate and adopt new technologies', impact: 'Technology roadmap' }
    ],
    responsibilities: [
      { area: 'Technical Strategy', tasks: ['Define technology roadmap', 'Evaluate new frameworks', 'Plan system evolution', 'Technology adoption'] },
      { area: 'Team Leadership', tasks: ['Lead engineering teams', 'Mentor senior developers', 'Drive technical culture', 'Cross-team collaboration'] },
      { area: 'System Architecture', tasks: ['Design enterprise systems', 'Plan scalability', 'Ensure system reliability', 'Security architecture'] }
    ],
    ceremonies: [
      { name: 'Engineering Leadership', frequency: 'Weekly', duration: '2 hours', role: 'Technical strategy lead' },
      { name: 'Architecture Board', frequency: 'Monthly', duration: '3 hours', role: 'Senior architect' },
      { name: 'Technology Review', frequency: 'Quarterly', duration: '4 hours', role: 'Technology evaluation lead' }
    ]
  }
};
